/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsMachineSubscription,
    MelcoModelsMachineSubscriptionFromJSON,
    MelcoModelsMachineSubscriptionFromJSONTyped,
    MelcoModelsMachineSubscriptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsUserMachineLicenseAssignmentItem
 */
export interface MelcoModelsUserMachineLicenseAssignmentItem {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserMachineLicenseAssignmentItem
     */
    license_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserMachineLicenseAssignmentItem
     */
    display_name?: string | null;
    /**
     * 
     * @type {Array<MelcoModelsMachineSubscription>}
     * @memberof MelcoModelsUserMachineLicenseAssignmentItem
     */
    machine_subscription?: Array<MelcoModelsMachineSubscription> | null;
}

export function MelcoModelsUserMachineLicenseAssignmentItemFromJSON(json: any): MelcoModelsUserMachineLicenseAssignmentItem {
    return MelcoModelsUserMachineLicenseAssignmentItemFromJSONTyped(json, false);
}

export function MelcoModelsUserMachineLicenseAssignmentItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUserMachineLicenseAssignmentItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'license_id': !exists(json, 'license_id') ? undefined : json['license_id'],
        'display_name': !exists(json, 'display_name') ? undefined : json['display_name'],
        'machine_subscription': !exists(json, 'machine_subscription') ? undefined : (json['machine_subscription'] === null ? null : (json['machine_subscription'] as Array<any>).map(MelcoModelsMachineSubscriptionFromJSON)),
    };
}

export function MelcoModelsUserMachineLicenseAssignmentItemToJSON(value?: MelcoModelsUserMachineLicenseAssignmentItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'license_id': value.license_id,
        'display_name': value.display_name,
        'machine_subscription': value.machine_subscription === undefined ? undefined : (value.machine_subscription === null ? null : (value.machine_subscription as Array<any>).map(MelcoModelsMachineSubscriptionToJSON)),
    };
}


